<template>
  <div class="firmDetail">
      <div class="firm-detail">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-if="this.$route.query.type === 'door'" :to="{ path: '/firm' }">企业</el-breadcrumb-item>
            <el-breadcrumb-item v-if="this.$route.query.type === 'door'" class="current-page">企业详情</el-breadcrumb-item>
          </el-breadcrumb>

          <div class="firm-detail-main">
              <div class="firm-tits">
                  <p class="firm-tit"
                    v-for="(item,index) in pageNavList"
                    :key="index"
                    :class="{itemClick:itemClickItem === index}"
                    @click="toModule(item.id,index)">
                      {{item.name}}
                  </p>
              </div>

              <div class="firm-main">
                  <div class="survey" id="survey">
                    <span class="title">企业概况</span>
                    <div class="base-survey flex-row">
                        <!-- 概况信息 -->
                        <div>
                            <div class="firm-info ">
                              <img class="logo" :src="firmDetailList.logo ? firmDetailList.logo : defaultImg" alt="">
                                <div style="text-align:left;">
                                     <a :title="firmDetailList.name" class="firm-name">{{firmDetailList.name | limitWordText(12)}}</a>
                                     <p class="firm-tag" v-if="isTag!==0">最具成长性创业企业</p>
                                     <p style="text-align: left;line-height:1.5;">
                                        <img class="icon" src="@/assets/firm-garden/icon-site.png" >
                                        <span class="icon-content" :title="firmDetailData.registryAddress">{{firmDetailData.registryAddress | limitWordText(15)}}</span>
                                     </p>
                                     <p style="text-align: left;">
                                         <img class="icon" src="@/assets/firm-garden/icon-call.png" alt="">
                                         <span class="icon-content">{{firmDetailData.phone}}</span>
                                     </p>
                                     <p style="text-align: left;">
                                         <img class="icon" src="@/assets/firm-garden/icon-web.png" alt="">
                                         <span class="icon-content">{{firmDetailData.website}}</span>
                                     </p>
                                </div>
                            </div>
                            <p class="firm-content" v-html="firmDetailList.detail"></p>
                        </div>
                        <!-- 企业概况轮播图 -->
                        <el-carousel class="firm-pic" trigger="click" height="300px">
                          <el-carousel-item v-for="(item,index) in firmPictures" :key="index">
                            <img :src="item ? item : defaultImg" alt="">
                          </el-carousel-item>
                        </el-carousel>
                    </div>

                    <!-- 企业基本信息 -->
                    <div class="content-info">
                        <p class="first-row">
                            <span class="first-line">法人代表：{{firmDetailData.legalRepresentative ? firmDetailData.legalRepresentative : noData}}</span>
                            <span class="second-line" v-if="firmDetailData.foundationDate">成立日期：{{firmDetailData.foundationDate ? firmDetailData.foundationDate.slice(0,3).join('-') : noData}}</span>
                            <span class="third-line">注册资本：{{firmDetailData.registryCapital ? firmDetailData.registryCapital : noData}}</span>
                            <span class="fouth-line">公司类型：{{firmDetailData.type ? firmDetailData.type : noData}}</span>
                        </p>
                        <p class="second-row">
                            <span class="first-line">行业分类：{{firmDetailData.industry ? firmDetailData.industry : noData}}</span>
                            <span class="second-line">经营状态：{{firmDetailData.bussinessState ? firmDetailData.bussinessState : noData}}</span>
                            <span class="third-line">人员规模：{{ firmDetailData.scale ? firmDetailData.scale : noData}}</span>
                            <span class="fouth-line">上一年营收：{{firmDetailList.income ? firmDetailList.income : noData}}</span>
                        </p>
                        <p class="second-row">
                            <span class="first-line">融资轮次：{{firmDetailList.financialTurn ? firmDetailList.financialTurn : noData}}</span>
                            <span class="second-line">融资金额：{{firmDetailList.financialNums ? firmDetailList.financialNums : noData}}</span>
                            <span class="third-line">是否高新：{{firmDetailData.isHightech ? firmDetailData.isHightech : noData}}</span>
                            <span class="fouth-line">是否上市：{{firmDetailData.isPublic ? (firmDetailData.isPublic === 0 ? '是' : '否') : noData}}</span>
                        </p>
                        <p class="second-row">
                            <span class="first-line">知识产权数：{{firmDetailData.patentNumber ? firmDetailData.patentNumber : noData}}</span>
                            <span class="second-line">社会统一信用代码：{{firmDetailData.creditCode ? firmDetailData.creditCode : noData}}</span>
                        </p>
                        <p class="second-row">
                            <span class="first-line">主要人员：
                              <span>{{mainMan ? mainMan : noData}}</span>
                            </span>
                        </p>
                    </div>
                  </div>

                  <div class="serve" id="serve">
                      <span class="title">产品服务</span>
                      <!-- <p style="color:#8F9096" v-html="autoPlay(firmDetailList.product)"></p> -->
                      <p class="pre" v-html="autoPlay(firmDetailList.product)"></p>
                  </div>

                  <div class="introduce" id="introduce">
                      <span class="title">团队介绍</span>
                      <!-- <p style="color:#8F9096" v-html="firmDetailList.teamIntroduce"></p> -->
                      <p class="pre" v-html="autoPlay(firmDetailList.teamIntroduce)"></p>
                  </div>

                  <div class="honor" id="honor">
                      <span class="title">荣誉资质</span>
                      <!-- <p style="color:#8F9096" v-html="firmDetailList.gloryDetail"></p> -->
                      <pre class="pre" v-html="firmDetailList.gloryDetail"></pre>
                      <div v-if="GetAwardprojects.length===1 && firmDetailList.gloryPicture">
                          <img v-for="(item,index) in firmDetailList.gloryPicture.split(',')"
                            :key="index"
                            :src="item"
                            style=" width: 303px;height: 216px;margin-right:12px;">
                        <!-- {{firmDetailList.gloryPicture.split(',')}} -->
                      </div>
                      <el-carousel class="slideshow-project" indicator-position="outside" v-if="GetAwardprojects.length>1">
                        <el-carousel-item class="project-item" v-for="(items,indexs) in GetAwardprojects" :key="indexs">
                            <div class="project"
                                v-for="(item,index) in items"
                                :key="index">
                                <img :src="item ? item.trim() : defaultImg" alt="">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                  </div>

                  <div class="develop" id="develop">
                      <span class="title">发展历程</span>
                      <!-- <p style="color:#8F9096" v-html="firmDetailList.developProcedure"></p> -->
                      <pre class="pre" v-html="autoPlay(firmDetailList.developProcedure)"></pre>
                  </div>

                  <div class="partner" id="partner">
                      <span class="title">合作伙伴</span>
                      <!-- <p style="color:#8F9096" v-html="firmDetailList.partner"></p> -->
                      <pre class="pre" v-html="autoPlay(firmDetailList.partner)"></pre>
                  </div>

              </div>
          </div>
      </div>

      <return-top v-if="this.$route.query.type === 'door'"></return-top>
  </div>
</template>

<script>
import ReturnTop from '@/components/returnTop.vue'
import mixinFun from '@/utils/mixin'
export default {
  name: 'firmDetail',
  props: {},
  mixins: [mixinFun],
  components: {
    ReturnTop

  },
  data () {
    return {
      noData: '暂无数据',
      defaultImg: require('@/assets/home/lostImg.png'),
      itemClickItem: null,
      pageNavList: [
        {
          id: 'survey',
          name: '企业概况'
        },
        {
          id: 'serve',
          name: '产品服务'
        },
        {
          id: 'introduce',
          name: '团队介绍'
        },
        {
          id: 'honor',
          name: '荣誉资质'
        },
        {
          id: 'develop',
          name: '发展历程'
        },
        {
          id: 'partner',
          name: '合作伙伴'
        }
      ],
      firmDetailList: {},
      firmDetailData: {},
      isTag: null,
      firmPictures: [], // 企业照片
      mainMan: [], // 主要人员
      projects: [],
      GetAwardprojects: [] // 双层数组嵌套获奖项目数据
    }
  },
  computed: {},
  created () {
    this.getDetailData()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '7'
  },
  methods: {
    // 富文本自动播放
    autoPlay (item) {
      if (item) {
        return item.replace('<video', '<video autoplay="autoplay" muted ')
      }
      // return item.replace('<video', '<video autoplay="autoplay" muted ')
    },

    // 页面锚点
    toModule (id, index) {
      this.itemClickItem = index
      if (id === 'survey') {
        document.querySelector('#survey').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'serve') {
        document.querySelector('#serve').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'introduce') {
        document.querySelector('#introduce').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'honor') {
        document.querySelector('#honor').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'develop') {
        document.querySelector('#develop').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'partner') {
        document.querySelector('#partner').scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },

    // 获取详情页数据
    async getDetailData () {
      try {
        const res = await this.$get(this.$url.firm.firmDetail + this.$route.query.id)

        const { code, msg, data } = res.data
        if (code === 200) {
          this.firmDetailList = data.info
          this.firmDetailData = data.basic
          this.isTag = data.appraiseTime
          // 企业图
          this.firmPictures = data.info.companyPicture
          console.log(this.firmPictures)
          if (this.firmPictures == null) {
            this.firmPictures = []
          } else {
            this.firmPictures = this.firmPictures.split(',')
          }
          // 主要人员
          try {
            this.mainMan = JSON.parse(data.basic.keyPersonnel)
          } catch (e) {
            this.mainMan = data.basic.keyPersonnel
          }
          //           try{
          //             this.basicForm.keyPersonnel = JSON.parse(data.keyPersonnel)
          //             this.basicForm.keyPersonnelFormat = ""

          //             for(let item of this.basicForm.keyPersonnel){
          //               this.basicForm.keyPersonnelFormat += (item.name+' ')
          //             }
          //           }catch (e) {
          //             this.basicForm.keyPersonnel = data.keyPersonnel
          //             this.basicForm.keyPersonnelFormat = data.keyPersonnel
          // }

          // 荣誉资质图片
          // this.projects = data.info.gloryPicture.replace('[', '').replace(']', '').split(',')
          this.projects = data.info.gloryPicture.split(',')
          const sumStr = []
          const index = Math.ceil(this.projects.length / 6)
          for (let i = 0; i < index; i++) {
            const passStr = this.projects.splice(0, 6)
            sumStr.push(passStr)
          }
          this.GetAwardprojects = sumStr
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.firmDetail{
    width: 100%;
    min-height: 100vh;
    margin-top: 8px;
    background-color: #F5F5F5;
    border: 1px solid #F5F5F5;
}
.pre{
  font-size: 16px;
  color: #000;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: "Microsoft YaHei";
}
.firm-detail{
    width: 1200px;
    margin: 10px auto 0;
}
.firm-detail-main{
    display: flex;
    .firm-tits{
      position: sticky;
      top: 0;
      width: 190px;
      height: 350px;
      background-color: #fff;
      margin: 10px 20px 0 0 ;
      cursor: pointer;
      .firm-tit{
        text-align: center;
        margin-top: 23px;
        font-size: 18px;
      }
    }
    .firm-main{
        width: 1003px;
        min-height: 800px;
        background-color: #fff;
        margin: 10px 0 100px;
        box-sizing: border-box;
        padding: 30px 20px;
        .serve{
          margin-top: 270px;
        }
        .survey,
        .serve,
        .introduce,
        .honor,
        .develop,
        .partner{
            box-sizing: border-box;

            .title{
              display: inline-block;
              padding-left: 10px;
              font-size: 20px;
              border-left: 4px solid #3056D9;
              border-radius: 1px 0 0 1px;
              margin: 38px 0 20px;
            }
            .logo{
                width: 179px;
                height: 128px;
                margin-right: 36px;
            }
            .firm-name{
              font-size: 20px;
            }
            .firm-tag{
                width: 120px;
                background-color: #FBF5E7;
                color: #926602;
                box-sizing: border-box;
                text-align: center;
                padding: 5px 0;
                font-size: 12px;
                margin-top: 10px;
            }
            .icon{
                width: 8px;
                height: 10px;
                margin-right: 5px;
            }
            .icon-content{
                display: inline-block;
                color: #898B91;
                font-size: 14px;
                // margin-top: 10px;
            }
        }
        .base-survey{
            display: flex;
            margin-top: 10px;
            position: relative;
            .firm-info{
                display: flex;
                position: absolute;
                top: 0
            }
            img{
                width: 458px;
                height: 299px;
            }
            .firm-content{
              position: absolute;
              top: 140px;
              width: 471px;
              font-size: 14px;
              text-align: left;
              // color: #898B91;
              color: #000;
              line-height: 1.5;
              margin: 15px 0 0;
            }
          .firm-pic{
            position: absolute;
            top: -55px;
            left: 500px;
            width: 458px;
            height: 300px;
            /deep/.el-carousel__arrow{
              top: 50%;
            }
          }
        }
        .content-info{
            position: relative;
            top: 295px;
            .first-row{
                margin-top: 32px;
            }
            .first-line,
            .second-line,
            .third-line,
            .fouth-line{
                font-size: 14px;
                font-family: "Microsoft YaHei";
                line-height: 1.5;
            }
            .second-row{
                margin-top: 20px;
            }
            .second-line{
                position: absolute;
                left: 295px;
            }
            .third-line{
                position: absolute;
                left: 525px;
            }
            .fouth-line{
                position: absolute;
                left: 750px;
            }
        }
        .slideshow-project{
            width: 955px;
            height: 530px;
            box-sizing: border-box;
            // border: 1px solid red;
            margin: 20px 0 0;
            .project-item{
                display: flex;
                flex-wrap: wrap;
                height: 450px;
                // border: 1px solid blue;
                .project{
                    margin-right: 20px;
                    img{
                        width: 303px;
                        height: 216px;
                    }
                }
                .project:nth-of-type(3n){
                    margin-right: 0;
                }
            }
            /deep/.el-carousel__indicators{
                // border: 1px solid blueviolet;
                margin-top: 180px;
            }
            /deep/.el-carousel__button{
                width: 46px;
                height: 9px;
                background: #3056D9;
                border-radius: 3px;
            }
        }
    }
}

.itemClick{
  color: #3056D9;
}

/deep/.is-link {
  font-size: 16px;
  font-weight: 400;
  color: #000 !important;
  text-decoration: underline;
}
.current-page{
   /deep/.el-breadcrumb__inner{
        color: #3c60db !important;
        text-decoration: none;
    }
}
/deep/.el-carousel__arrow{
  top: 72%;
}

</style>
